module.exports = __webpack_public_path__ + "static/img/banner05.c1c89e2c.png";